import { useEffect, useRef } from 'react';
import type { Anime } from '../lib/types';

const W = 220;
const H = 330; // AniList covers are ~2:3

// Real mosaic via offscreen downsample + nearest-neighbor upscale (best-practice §11.7):
// NOT a blur. Pixelation eases off with each guess; full reveal on solve/lose.
export default function PixelView({
  answer,
  guessCount,
  revealed,
}: {
  answer: Anime;
  guessCount: number;
  revealed: boolean;
}) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !answer.cover) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const img = new Image();
    img.onload = () => {
      ctx.clearRect(0, 0, W, H);
      if (revealed) {
        ctx.imageSmoothingEnabled = true;
        ctx.drawImage(img, 0, 0, W, H);
        return;
      }
      const blocks = Math.min(72, 7 + guessCount * 6); // 7px wide at first
      const sw = blocks;
      const sh = Math.max(1, Math.round((blocks * H) / W));
      const off = document.createElement('canvas');
      off.width = sw;
      off.height = sh;
      const octx = off.getContext('2d')!;
      octx.imageSmoothingEnabled = true;
      octx.drawImage(img, 0, 0, sw, sh);
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(off, 0, 0, sw, sh, 0, 0, W, H);
    };
    img.src = answer.cover;
  }, [answer.cover, guessCount, revealed]);

  return <canvas ref={ref} width={W} height={H} className="pixel" aria-label="Pixelated anime cover" />;
}
